/**
 * Import all module depenencies here.
 * Add commonly used modules to externals.
 */
import core from '../../app.core.module.js';
import changepasswordConfig from './changepassword.config.js';
import changepasswordRoute from './changepassword.route.js';
import changepasswordController from './changepassword.controller.js';

/**
 * This is the changepassword module. It it the entry point for this website.
 * Only declare the module's dependencies in this file.
 * @namespace changepassword Module
 */
angular.module('changepassword', [
  // Shared modules.
  core
])
// Register config.
.config(changepasswordConfig)
// Register route.
.config(changepasswordRoute)
// Register controller.
.controller('changepasswordController', changepasswordController)

export default 'changepassword';


// WEBPACK FOOTER //
// ./src/login/changepassword/changepassword.module.js